export default __webpack_public_path__ + "static/media/bsnl.8c1472c2.svg";